<template>
  <section>
    <ChartWarningForIE
      v-if="chartWarning"
      @click="chartWarning = false"
    />
    <!-- 그래프 -->
    <div v-else class="section_graph">
      <Chart v-if="tableItems" :chartData="tableItems" :key="chartKey"></Chart>
      <div v-else style="font-size:15px; text-align:center;"><div><span>조회결과가 없습니다.</span></div></div>
    </div>
    <!-- //그래프 -->

    <PlainTable ref="table" :sourceList="tableItems" :useExcel="true">
      <template #header>
        <caption><span class="blind">통계 목록</span></caption>
        <colgroup>
          <col>
          <col width="11%">
          <col width="11%">
          <col width="11%">
          <col width="11%">
          <col width="11%">
          <col width="11%">
          <col width="11%">
          <col width="11%">
        </colgroup>

        <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">날짜</th>
          <th rowspan="2">요청 전체</th>
          <th v-for="(item, index) in headerInfo" :key="index" :colspan="item.sub.length">{{item.name}}</th>
        </tr>
        <tr>
          <template v-for="(item, pi) in headerInfo">
            <th v-for="(subItem, si) in item.sub" :key="`${pi}${si}`">{{subItem}}</th>
          </template>
        </tr>
        </thead>
      </template>
      <template #row="{rowData}">
          <tr>
            <td>{{rowData.date}}</td>
            <td class="right">{{rowData.count}}</td>
            <td v-for="(countNum, index) in rowData.statCountList" :key="index" class="right">{{countNum}}</td>
          </tr>
      </template>
    </PlainTable>
    <p class="table_data_desc"><span class="dot">*</span> 소식톡톡 등록 건수는 그룹전송 건수만 집계됩니다.</p>

    <div v-if="tableItems" class="section_button none_paginate">
      <button type="button" class="btn_excel" @click="excelDownload"><span class="ico"></span>엑셀저장</button>
    </div>
  </section>
</template>

<script>
import Chart from './Chart'
import XLSX from 'xlsx'
import ChartWarningForIE from "$views/Stats/ChartWarningForIE";

export default {
  props: {
    statData: Array,
    excelName: {
      type: String,
      default: 'table'
    }
  },
  data() {
    return {
      chartWarning: this.$utils.isIE,
      chartKey: Date.now()
    }
  },
  watch: {
    statData() {
      this.chartKey = Date.now()
    }
  },
  components: { Chart, ChartWarningForIE },

  computed: {
    headerInfo() {
      if (_.isEmpty(this.statData)) return [{"name":"소식톡톡","sub":["등록","전송","확인"]},{"name":"두뇌톡톡","sub":["요청","완료"]},{"name":"건강톡톡","sub":["요청","검색"]}]
      const sample = this.statData[0]
      return _.map(sample.stat, item => {
        return {
          name: item.name,
          sub: _.map(item.categories, subItem => subItem.categoryName)
        }
      })
    },
    tableItems() {
      if (_.isEmpty(this.statData)) return null
      return _.map(this.statData, item => {
        const statCountData = {}
        const statCountList = _.map(item.stat, subItem => {
          return _.map(subItem.categories, cateItem => {
            statCountData[`${subItem.name} - ${cateItem.categoryName}`] = cateItem.count
            return cateItem.count
          })
        })
        return {
          date: item.date,
          count: item.count,
          statCountList: _.flatten(statCountList),
          ...statCountData
        }
      })
    }
  },
  methods: {
    excelDownload() {
      const table = this.$refs.table.getExcelTable()
      const wb = XLSX.utils.table_to_book(table, {sheet: this.excelName})
      XLSX.writeFile(wb, `${this.excelName}.xlsx`)
    },
  }
}
</script>
